import React from "react";
import {
  AlternateApproverSelect,
  Box,
  DatePicker,
} from "../../../../../../components";
import { Col, Form, Input, Row, Select } from "antd";

export const CreateECVietnameseForm = () => {
  return (
    <Box title="Nội dung đề nghị">
      <Row gutter={[32, 0]}>
        <Col span={12} xs={24} md={12}>
          <Form.Item required label="Họ và tên" name="requestName">
            <Input />
          </Form.Item>
        </Col>
        <Col span={12} xs={24} md={12}>
          <Form.Item required label="Số CMND/CCCD" name="socmnd">
            <Input />
          </Form.Item>
        </Col>
        <Col span={12} xs={24} md={12}>
          <Form.Item required label="Ngày vào ngành" name="ngayvaonganh">
            <DatePicker className="min-w-full" />
          </Form.Item>
        </Col>
        <Col span={12} xs={24} md={12}>
          <Form.Item required label="Chức vụ" name="chucvu">
            <Input />
          </Form.Item>
        </Col>
        <Col span={12} xs={24} md={12}>
          <Form.Item
            label="Chi nhánh (KCQ bỏ qua phần chi nhánh)"
            name="chinhanh"
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={12} xs={24} md={12}>
          <Form.Item
            required
            label="Giấy chứng nhận này cấp cho Ông/Bà"
            name="giaychungnhan"
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={12} xs={24} md={12}>
          <Form.Item required label="Ngày hết hạn" name="ngayhethan">
            <DatePicker className="min-w-full" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[32, 0]}>
        <Col span={12} xs={24} md={12}>
          <Form.Item required label="Người duyệt" name="approverBy">
            <Select placeholder="Chọn người duyệt" />
          </Form.Item>
        </Col>
        <Col span={12} xs={24} md={12}>
          <Form.Item label="Người duyệt thay thế" name="alternateApproverBy">
            <AlternateApproverSelect />
          </Form.Item>
        </Col>
      </Row>
    </Box>
  );
};
